export default "__VITE_ASSET__jSN$D5yN__"